<template>
	<div style="background-color: #f8f8f8;height: calc(100% - 50px);overflow: auto;">
		<div class="content">
			<div class="statisticsInfo">
				<p class="title" @click="jumpListAll()">漏洞总数:
					<span>
						{{this.vulnerabilityInfos.total}}
					</span>
				</p>
				<div class="list">
					<div @click="jumpList(1)">
						<p class="grade">高危漏洞</p>
						<p class="num" style="color: #Eb504e;">
							{{this.vulnerabilityInfos.high}}
						</p>
					</div>
					<div @click="jumpList(2)">
						<p class="grade">中危漏洞</p>
						<p class="num" style="color: #e8c115;">
							{{this.vulnerabilityInfos.middle}}
						</p>
					</div>
					<div @click="jumpList(3)">
						<p class="grade">低危漏洞</p>
						<p class="num" style="color: #399af8;">
							{{this.vulnerabilityInfos.low}}
						</p>
					</div>
					<!--                    <div>-->
					<!--                        <p class="grade">未知漏洞</p>-->
					<!--                        <p class="num">-->
					<!--                            {{this.vulnerabilityInfos.unknown}}-->
					<!--                        </p>-->
					<!--                    </div>-->
				</div>
			</div>
			<div class="hazardLevel">
				<div class="chartTitle">
					<p class="name">漏洞危害等级分布</p>
				</div>
				<div class="chartBox">
					<div style="width:40%;height: 80px" id="echartsPieTwo"></div>
					<ul class="labelList" style="width: 60%;">
						<li v-for="(item,i) in this.bugDanger" :key="i">
							<span class="label"></span>
							<p class="level">
								{{item.name}}
								<span>
									{{item.value}}
								</span>
							</p>
							<p class="level">占比
								<span>
									{{(item.value / totalSumAll * 100).toFixed(1)}}
								</span>
								%
							</p>
						</li>
					</ul>
				</div>
			</div>
			<div class="loopholeTrend">
				<div class="chartTitle">
					<p class="name">漏洞趋势</p>
					<div class="rangeTime">
						<div class="rangeTime-child" @click="selectDate">{{startDate}} ~ {{endDatePie}}</div>
						<calendar :show.sync="show" :defaultDate="defaultDate" mode="during" @change="onChange" />
					</div>
				</div>
				<div style="width: 100%;height: 250px;" id="echartLine"></div>
				<p class="description">
					<span>*</span>
					从{{this.startDate}}到{{this.endDatePie}}，累计新增漏洞<span>{{total}}</span>条，
					平均每天新增<span>{{midNum}}</span>条，
					新增漏洞数最高的日期为<span>{{maxDate}}</span>。
				</p>
			</div>
			<div class="annualStatistics">
				<div class="chartTitle">
					<p class="name">CNVD收录漏洞数量年度统计</p>
					<div style="width: 95px;padding: 3px 0 3px 10px;height: 26px;line-height: 23px;background-color: #fff;background-image: none;border-radius: 4px;border: 1px solid #dcdfe6;">
						<span style="display: inline-block;width: 100%;text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
						 @click="showPopupCnvd">
							{{startDateCnvd}}
						</span>
					</div>
					<van-popup v-model="cnvdShow" round position="bottom">
						<van-picker show-toolbar :columns="columns" @cancel="cnvdShow = false" @confirm="onConfirm" :default-index="11" />
					</van-popup>
					<!-- <van-popup v-model="cnvdShow" position="bottom" get-container="body" :style="{ height: '30%' }"  > -->
					<!-- <van-datetime-picker
                                v-model="cnvdCurr"
                                type="date"
                                title="选择年月"
                                @confirm="okTimeCnvd"
                                @cancel="popHideCnvd"
                        /> -->
					<!-- </van-popup> -->
				</div>
				<div style="width: 100%;height: 250px;" id="echartLineTwo"></div>
				<p class="description">
					<span>*</span>
					{{startDateCnvd}}年度内累计新增漏洞<span>{{totalTwo}}</span>条
					，平均每月新增<span>{{midNumTwo}}</span>条
					，新增漏洞数最高的月份为<span>{{maxMonth == '暂无'?'暂无':maxMonth + '月'}}</span>。
				</p>
			</div>
			<!--            <div class="typeStatistics">-->
			<!--                <div class="chartTitle">-->
			<!--                    <p class="name" style="font-size: .12rem;">漏洞类型统计(Top-10)</p>-->
			<!--                    <div style="width: 1.95rem;padding: .03rem 0 .03rem .1rem;height: 26px;line-height: 23px;background-color: #fff;background-image: none;border-radius: 4px;border: 1px solid #dcdfe6;">-->
			<!--                        <span style="display: inline-block;width: 40%;text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" @click="showPopupTop">-->
			<!--                            {{startDateTop}}-->
			<!--                        </span>-->
			<!--                        <span style="display: inline-block;width: 10%;text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">~</span>-->
			<!--                        <span style="display: inline-block;width: 40%;text-align: center;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" @click="showPopupTop2">-->
			<!--                            {{endDateTop}}-->
			<!--                        </span>-->
			<!--                    </div>-->
			<!--                    <van-popup v-model="showTop" position="bottom" get-container="body" :style="{ height: '30%' }"  >-->
			<!--                        <van-datetime-picker-->
			<!--                                v-model="currentDateTop"-->
			<!--                                type="date"-->
			<!--                                title="选择年月日"-->
			<!--                                @confirm="okTimeTop"-->
			<!--                                @cancel="popHideTop"-->
			<!--                        />-->
			<!--                    </van-popup>-->
			<!--                    <van-popup v-model="endShowTop" position="bottom" get-container="body" :style="{ height: '30%' }"  >-->
			<!--                        <van-datetime-picker-->
			<!--                                v-model="currentDateTop2"-->
			<!--                                type="date"-->
			<!--                                title="选择年月日"-->
			<!--                                @confirm="okTimeTop2"-->
			<!--                                @cancel="popHideTop2"-->
			<!--                        />-->
			<!--                    </van-popup>-->
			<!--                </div>-->
			<!--                <div style="width: 100%;height: 2.5rem;" id="echartBar"></div>-->
			<!--&lt;!&ndash;                <p class="description">&ndash;&gt;-->
			<!--&lt;!&ndash;                    <span>*</span> 从{{this.startDateTop}}到{{this.endDateTop}}，占比前三漏洞为通用型&ndash;&gt;-->
			<!--&lt;!&ndash;                </p>&ndash;&gt;-->
			<!--            </div>-->
		</div>
		<div class="footerPages">
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	import Foot from '../../components/phoneHeader/footerPhone'
	import echarts from 'echarts'
	import {
		getCountNumber,
		getNew,
		getHotBug,
		getBugLine,
		getBugPie,
		getBugPieTwo
	} from '../../api/index'
	import {
		getBugTrend,
		getBugYear,
		getBugType
	} from '../../api/bugEcharts'
	import DateUtil from "../../components/w.tool.date";
	export default {
		name: "bugEcharts",
		components: {
			Foot
		},
		data() {
			return {
				//时间范围参数定义
				show: false,
				date: '',
				defaultDate: ["2021-02-07", "2021-03-09"],
				columns: ['2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022',
					'2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030'
				],
				// 漏洞趋势时间弹出层
				show: false, //开始时间
				endShow: false, //结束时间
				// 漏洞趋势
				vulnerabilityInfos: {},
				lineDataName: [],
				lineDataValue: [],
				currentDate: new Date(), //开始时间
				startDate: '开始时间',
				currentDate2: new Date(),
				endDatePie: '结束时间',
				maxDate: '暂无数据',
				bugDanger: [],
				total: null,
				midNum: null,
				highDate: null,
				// CNVD年度统计
				cnvdShow: false,
				cnvdCurr: new Date(),
				startDateCnvd: null,
				highArr: [],
				lineName: [],
				midArr: [],
				lowArr: [],
				unNoArr: [],
				totalTwo: null,
				midNumTwo: null,
				maxMonth: '暂无',
				// 漏洞类型统计TOP10
				showTop: false,
				endShowTop: false,
				startDateTop: null,
				endDateTop: null,
				currentDateTop: new Date(),
				currentDateTop2: new Date(),
				allStart: '',
				allend: '',
				barData: [],
				barName: [],
				barVal: [],
				//漏洞趋势日期
			}
		},
		computed: {
			totalSumAll() {
				let totalSumAll = 0;
				this.bugDanger.map((item) => {
					totalSumAll += parseInt(item.value)

				})
				return totalSumAll
			},
		},
		methods: {
			/**=============跳转到漏洞列表页面的方法================== */
			//漏洞总数跳转
			jumpListAll() {
				this.$router.push({
					name: 'bugListphone'
				})
			},
			jumpList(val) {
				if (val === 1) {
					this.$router.push({
						name: 'bugListphone',
						params: {
							i: val,
							value: 3
						}
					})
				} else if (val === 2) {
					this.$router.push({
						name: 'bugListphone',
						params: {
							i: val,
							value: 2
						}
					})
				} else if (val === 3) {
					this.$router.push({
						name: 'bugListphone',
						params: {
							i: val,
							value: 1
						}
					})
				}

			},
			//范围日期方法
			selectDate() {
				this.show = true;
				this.date = '';
			},
			onChange(date) {
				this.date = JSON.stringify(date.map((item) => item.format('YYYY-MM-DD')));
				var timeArr = JSON.parse(this.date)
				this.startDate = timeArr[0];
				this.endDatePie = timeArr[1];
				this.lineDataName = []
				this.lineDataValue = []
				this.total = null
				this.midNum = null
				this.echartsLine()
			},
			onConfirm(value) {
				this.startDateCnvd = value;
				this.cnvdShow = false;
				this.highArr = []
				this.lineName = []
				this.midArr = []
				this.lowArr = []
				this.unNoArr = []
				this.totalTwo = null
				this.midNumTwo = null
				this.echartsLineTwo()
			},
			// 日期处理
			getFormatDate(date, format) {
				let time = {
					'M+': date.getMonth() + 1,
					'd+': date.getDate()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' + time[k]).length))
					}
				}
				return format
			},
			getFormatDate2(date, format) {
				let time = {
					'M+': date.getMonth() + 2,
					'd+': date.getDate()
				}
				if (/(y+)/i.test(format)) {
					format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
				}
				for (let k in time) {
					if (new RegExp('(' + k + ')').test(format)) {
						format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? time[k] : ('00' + time[k]).substr(('' + time[k]).length))
					}
				}
				return format
			},
			// 漏洞趋势时间弹出层
			/*开始时间*/
			showPopup() {
				this.show = true;
			},
			popHide() {
				this.show = false;
				this.startDate = '开始时间'
			},
			okTime() {
				var d = new Date(this.currentDate)
				this.startDate = this.getFormatDate(d, 'yyyy-MM-dd')
				this.show = false;
			},
			/*结束时间*/
			showPopup2() {
				this.endShow = true;
			},
			popHide2() {
				this.endShow = false;
				this.endDatePie = '结束时间'
			},
			okTime2() {
				var d = new Date(this.currentDate2)
				this.endDatePie = this.getFormatDate(d, 'yyyy-MM-dd')
				this.endShow = false;
				this.lineDataName = []
				this.lineDataValue = []
				this.total = null
				this.midNum = null
				this.echartsLine()
			},

			// CNVD时间
			showPopupCnvd() {
				this.cnvdShow = true;
			},
			popHideCnvd() {
				this.cnvdShow = false;
				this.startDateCnvd = '开始时间'
			},
			okTimeCnvd() {
				var d = new Date(this.cnvdCurr)
				this.startDateCnvd = this.getFormatDate(d, 'yyyy')
				this.cnvdShow = false;
				this.highArr = []
				this.lineName = []
				this.midArr = []
				this.lowArr = []
				this.unNoArr = []
				this.totalTwo = null
				this.midNumTwo = null
				this.echartsLineTwo()
			},

			// 漏洞类型统计时间弹出层
			/*开始时间*/
			showPopupTop() {
				this.showTop = true;
			},
			popHideTop() {
				this.showTop = false;
				this.startDateTop = '开始时间'
			},
			okTimeTop() {
				var d = new Date(this.currentDateTop)
				this.startDateTop = this.getFormatDate(d, 'yyyy-MM-dd')
				this.showTop = false;
			},

			/*结束时间*/
			showPopupTop2() {
				this.endShowTop = true;
			},
			popHideTop2() {
				this.endShowTop = false;
				this.endDateTop = '结束时间'
			},
			okTimeTop2() {
				var d = new Date(this.currentDateTop2)
				this.endDateTop = this.getFormatDate(d, 'yyyy-MM-dd')
				this.endShowTop = false;
				this.barName = []
				this.barVal = []
				this.echartsBar();
			},

			// 获取当前时间
			getTime() {
				var day2 = new Date();
				day2.setTime(day2.getTime());
				this.endDatePie = this.getFormatDate(day2, 'yyyy-MM-dd');
				this.startDate = DateUtil.getBeforeNumToDate(30);

				this.startDateTop = this.getFormatDate(day2, 'yyyy-MM-dd');
				this.endDateTop = this.getFormatDate2(day2, 'yyyy-MM-dd');
				this.startDateCnvd = day2.getFullYear();

				this.allStart = this.getFormatDate(day2, 'yyyy-MM-dd');
				this.allend = day2.getFullYear() + "-" + (day2.getMonth() + 2) + "-" + day2.getDate();
			},
			// 获取漏洞数量
			getCount() {
				getCountNumber().then(res => {
					if (res.status == 200) {
						this.vulnerabilityInfos = res.data
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 最大值

			// 漏洞趋势
			echartsLine() {
				var params = {
					startDate: this.startDate,
					endDate: this.endDatePie
				}
				getBugTrend(params).then(res => {
					if (res.status == 200) {
						var dom = document.getElementById('echartLine');
						var myChart = this.echarts.init(dom);
						if (res.data.length == 0) {
							var max = 1
							var day2 = new Date();
							day2.setTime(day2.getTime());
							this.maxDate = this.getFormatDate(day2, 'yyyy-MM-dd');
							this.total = 0
							this.midNum = 0
						} else {
							var max = res.data[0].count
						}
						var sum = 1
						for (var i = 0; i < res.data.length; i++) {
							if (max < res.data[i].count) {
								max = res.data[i].count
								this.maxDate = res.data[i].type
								sum++
							}
							this.lineDataName.push(res.data[i].type)
							this.lineDataValue.push(res.data[i].count)
							this.total += parseInt(res.data[i].count)
							this.midNum = (this.total / parseInt(res.data.length)).toFixed(2)
						}
						if (sum == 1) {
							var day2 = new Date();
							day2.setTime(day2.getTime());
							this.maxDate = this.getFormatDate(day2, 'yyyy-MM-dd');
						}
						myChart.setOption({
							tooltip: {
								trigger: 'axis',
								axisPointer: {
									lineStyle: {
										color: '#ddd'
									}
								},
								padding: [5, 10],
							},
							grid: {
								top: '15%',
								bottom: '15%',
								left: '16%',
								right: '16%'
							},
							xAxis: {
								type: 'category',
								name: '时间',
								data: this.lineDataName,
								boundaryGap: false,
								splitLine: {
									show: false,
									interval: 'auto',
									lineStyle: {
										color: ['#D4DFF5']
									}
								},
								axisTick: {
									show: true
								},
								axisLine: {

									lineStyle: {
										color: '#000'
									}
								},
								axisLabel: {
									margin: 10,
									textStyle: {
										fontSize: 12
									}
								}
							},
							yAxis: {
								type: 'value',
								name: '数量',
								splitLine: {
									lineStyle: {
										color: ['#ccc']
									}
								},
								axisTick: {
									show: true
								},
								axisLine: {
									lineStyle: {
										color: '#000'
									}
								},
								axisLabel: {
									margin: 10,
									textStyle: {
										fontSize: 12
									}
								}
							},
							series: [{

								type: 'line',
								smooth: false,
								showSymbol: false,
								symbol: 'circle',
								symbolSize: 2,
								data: this.lineDataValue,
								areaStyle: {
									normal: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: '#d7ebfe'
										}, {
											offset: 1,
											color: '#d7ebfe'
										}], false)
									}
								},
								itemStyle: {
									normal: {
										color: '#58c8da'
									}
								},
								lineStyle: {
									normal: {
										width: 2,
										color: '#c6e3fd'
									}
								}
							}]
						})
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 危险等级分布
			echartsPieTwo() {
				getBugPieTwo().then(res => {
					if (res.status == 200) {
						this.bugDanger.push({
							value: res.data.high,
							name: '高危'
						}, {
							value: res.data.middle,
							name: '中危'
						}, {
							value: res.data.low,
							name: '低危'
						})
						var dom = document.getElementById('echartsPieTwo')
						var myChart = this.echarts.init(dom)
						var arr = this.bugDanger
						let total = arr.reduce((a, b) => {
							return a + b.value * 1
						}, 0)
						myChart.setOption({
							tooltip: {
								show: false,
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c} ({d}%)",
							},
							color: ['#Eb504e', '#e8c115', '#399af8'],
							series: [{
								name: '危险等级',
								type: 'pie',
								center: ['35%', '50%'],
								radius: ['70%', '95%'],
								avoidLabelOverlap: false,
								selectedMode: false,
								data: this.bugDanger,
								label: {
									normal: {
										position: 'inner',
										show: false
									}
								},
								itemStyle: {
									normal: {

									},
									emphasis: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},

							}]
						})
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})

			},
			// 影响对象类型统计
			echartsLineTwo() {
				var params = {
					year: this.startDateCnvd
				}
				getBugYear(params).then(res => {
					if (res.status == 200) {
						var dom = document.getElementById('echartLineTwo');
						var myChart = this.echarts.init(dom);
						var num = 0
						var max = parseInt(JSON.parse(res.data[0].high)) + parseInt(JSON.parse(res.data[0].middle)) + parseInt(JSON.parse(
							res.data[0].low)) + parseInt(JSON.parse(res.data[0].unknown));
						var min = 0
						this.maxMonth = 1
						for (var i = 0; i < res.data.length; i++) {
							min = parseInt(JSON.parse(res.data[i].high)) + parseInt(JSON.parse(res.data[i].middle)) + parseInt(JSON.parse(
								res.data[i].low)) + parseInt(JSON.parse(res.data[i].unknown))
							if (max < min) {
								max = min
								this.maxMonth = res.data[i].time
							}
							this.highArr.push(res.data[i].high)
							this.lineName.push(res.data[i].time)
							this.midArr.push(res.data[i].middle)
							this.lowArr.push(res.data[i].low)
							this.unNoArr.push(res.data[i].unknown)
							num += parseInt(JSON.parse(res.data[i].high)) + parseInt(JSON.parse(res.data[i].middle)) + parseInt(JSON.parse(
								res.data[i].low)) + parseInt(JSON.parse(res.data[i].unknown))
							this.totalTwo = num
							this.midNumTwo = (num / parseInt(res.data.length)).toFixed(2)
						}
						myChart.setOption({
							color: ["#f34f4e", "#eebd34", "#009ef3"],
							tooltip: {
								trigger: 'axis',
								axisPointer: { // 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								}
							},
							legend: {
								data: ['高危', '中危', '低危'],
								left: 'center',
								top:'28%',
							},
							grid: {
								left: '3%',
								right: '4%',
								top:'40%',
								bottom: '7%',
								containLabel: true
							},
							xAxis: [{
								type: 'category',
								data:this.lineName,
							}],
							yAxis: [{
								type: 'value'
							}],
							series: [
								{
									name: '高危',
									barWidth:10,
									type: 'bar',
									stack: '广告',
									emphasis: {
										focus: 'series'
									},
									data: this.highArr,
								},
								{
									name: '中危',
									barWidth:10,
									type: 'bar',
									stack: '广告',
									emphasis: {
										focus: 'series'
									},
									data: this.midArr,
								},
								{
									name: '低危',
									barWidth:10,
									type: 'bar',
									stack: '广告',
									emphasis: {
										focus: 'series'
									},
									data: this.lowArr,
								},
							]
						})
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 类型统计TOP10
			echartsBar() {
				var params = {
					startDate: this.startDateTop,
					endDate: this.endDateTop,
				}
				getBugType(params).then(res => {
					if (res.status == 200) {

						var dom = document.getElementById('echartBar');
						var myChart = this.echarts.init(dom);
						for (var i = 0; i < res.data.length; i++) {
							this.barData = res.data
							if (res.data[i].type == 0) {
								this.barName.push('通用型')
								this.barVal.push(res.data[i].count)
							} else {
								this.barName.push('事件型')
								this.barVal.push(res.data[i].count)
							}
						}
						myChart.setOption({
							color: ['#3398DB'],
							tooltip: {
								trigger: 'axis',
								axisPointer: { // 坐标轴指示器，坐标轴触发有效
									type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
								}
							},
							grid: {
								top: '15%',
								bottom: '15%',
								left: '8%',
								right: '12%',
								containLabel: true
							},
							xAxis: [{
								type: 'category',
								data: this.barName,
								axisTick: {
									alignWithLabel: true
								}
							}],
							yAxis: [

								{
									name: '数量',
									type: 'value',

								}
							],
							series: [{
								type: 'bar',
								barWidth: '60%',
								data: this.barVal
							}]
						})

					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
		},
		created() {
			this.getCount()
			this.getTime()
		},
		mounted() {
			this.echartsLineTwo();
			this.echartsLine();
			this.echartsPieTwo()
			// this.echartsBar();
		}
	}
</script>

<style scoped>
	p {
		margin-bottom: 0px;
	}

	.content {
		/* height: calc(100% - 1.6rem); */
		padding-bottom: 0;
		margin-top: 5px;
		width: 100%;
		padding: 0 12px 10px;
		text-align: left;
	}

	.footerPages {
		width: 100%;
		position: -webkit-sticky;
		position: sticky;
		bottom: -120px;
		/* position: fixed;
        bottom: 0; */
	}

	.content .statisticsInfo {
		padding-top: 15px;
		margin-bottom: 10px;
	}

	.content .statisticsInfo .title {
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		color: #666;
		margin-bottom: 10px;
	}

	.content .statisticsInfo .title span {
		font-size: 16px;
		font-weight: 700;
		color: #333;
		line-height: 20px;
		margin-left: 10px;
	}

	.content .statisticsInfo .list {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	.content .statisticsInfo .list div {
		/*width: .825rem;*/
		width: 112px;
		height: 60px;
		text-align: center;
		background-color: #fff;
		-webkit-box-shadow: 0 5px 20px 0 rgba(6, 3, 3, .03);
		box-shadow: 0 5px 20px 0 rgba(6, 3, 3, .03);
	}

	.content .statisticsInfo .list div .grade {
		font-size: 12px;
		font-weight: 400;
		color: #333;
		line-height: 20px;
		margin-top: 10px;
	}

	.content .statisticsInfo .list div .num {
		font-size: 16px;
		font-weight: 700;
		color: #333;
		line-height: 20px;
	}

	.hazardLevel {
		width: 100%;
		border-radius: 4px;
		background-color: #fff;
	}

	.chartTitle {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		padding: 10px 10px 10px 0;
	}

	.chartTitle .name {
		line-height: 14px;
		font-size: 14px;
		font-weight: 400;
		color: #333;
		border-left: 3px solid #2978c3;
		padding-left: 6px;
	}

	.chartTitle .rangeTime {
		width: 55%;
		height: 26px;
		line-height: 26px;
	}

	.rangeTime-child {
		border: 1px solid rgb(220, 223, 230);
		border-radius: 4px;
		text-align: center;
	}

	.hazardLevel .chartBox {
		padding: 15px 20px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
	}

	.hazardLevel .chartBox {
		padding: 15px 20px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
	}

	.labelList li {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		margin-top: 9px;
	}

	.labelList li:first-child .label {
		background-color: #f34a65;
	}

	.labelList li .level {
		width: 75px;
		font-size: 12px;
		font-weight: 400;
		color: #333;
		line-height: 13px;
		margin-top: 5px;
	}

	.labelList li .label {
		width: 13px;
		height: 13px;
		display: inline-block;
		border-radius: 2px;
		margin-right: 20px;
	}

	.labelList li .level span {
		font-weight: 700;
	}

	.labelList li:first-child .label {
		background-color: #f34a65;
	}

	.labelList li:nth-child(2) .label {
		background-color: #e8c115;
	}

	.labelList li:nth-child(3) .label {
		background-color: #399af8;
	}

	.labelList li:nth-child(4) .label {
		background-color: #fa902d;
	}

	.labelList li:first-child {
		margin-top: 0;
	}

	.loopholeTrend {
		width: 100%;
		border-radius: 4px;
		background-color: #fff;
		padding-bottom: 10px;
		margin-top: 10px;
	}

	/deep/ .ant-calendar-range {
		width: 100% !important;
	}

	.description {
		padding: 10px;
		font-size: 12px;
		line-height: 20px;
		font-weight: 400;
		color: #666;
	}

	.description span {
		color: #333;
		font-weight: 700;
	}

	.annualStatistics {
		width: 100%;
		border-radius: 4px;
		background-color: #fff;
		padding-bottom: 10px;
		margin-top: 10px;
	}

	.typeStatistics {
		width: 100%;
		border-radius: 4px;
		background-color: #fff;
		padding-bottom: 10px;
		margin-top: 10px;
	}
</style>
